import { GeneralPhotoRemarksDto } from "../write/generalPhotoRemarksDto";
import { Building } from "./Building";
import { Layout, LayoutProps } from "./Layout";
import { Quadrant } from "../../../core/survey/inside-survey/models/quadrant.enum";
import { InsideIntroduction } from "../../../core/survey/inside-survey/models/insideIntroduction.enum";
import { CopperIntroType } from "../../../core/survey/inside-survey/models/copperIntroType.enum";
import { ExistingTelcoCoax } from "../../../core/survey/inside-survey/models/existingTelcoCoax.enum";
import { ExistingTelcoConnections } from "../../../core/survey/inside-survey/models/existingTelcoConnections.enum";
import { ExistingVerticalCabling } from "../../../core/survey/inside-survey/models/existingVerticalCabling.enum";
import { SurveyStatus } from "../enums/SurveySurveyStatus";
import { ProximusEquipmentPhotoRemarksDto } from "../write/ProximusEquipmentPhotoRemarksDto.1";
import { TSAType } from "src/app/core/survey/inside-survey/models/tsaType.enum";

export default class InsideSurvey {
  id: string;
  insideEngineer: {
    firstName: string;
    lastName: string;
  };
  facadePhotoRemark: string;
  undergroundPhotoRemark: string;
  outsideIntroPhotoRemark: string;
  generalTechnicalInfoPhotoRemark: ProximusEquipmentPhotoRemarksDto[];
  electricityEquipmentPhotoRemark: string;
  outsideCopperIntroPhotoRemark: string;
  insideCopperIntroPhotoRemark: string;
  outsideFibreIntroPhotoRemark: string;
  insideFibreIntroPhotoRemark: string;
  electricityInTelcoRoomPhotoRemark: string;
  roomAvailableForNewEquipmentPhotoRemark: string;
  telcoRoomPhotoRemark: string;
  generalPhotoRemark: GeneralPhotoRemarksDto[];
  proximusEquipmentPhotoRemark: ProximusEquipmentPhotoRemarksDto[];
  buildings: Building[];
  photos: any;
  shouldUpdateLayout: boolean;
  quadrant: Quadrant;
  introduction: InsideIntroduction;
  horizontalTechnicalShaft: boolean;
  verticalTechnicalShaft: boolean;
  electricityInTelcoRoom: boolean;
  roomAvailableForFutureIntroBox: boolean;
  otherTelcoRemarks: string;
  individualCoaxCableFromBasement: boolean;
  copperIntroType: CopperIntroType;
  existingTelcoCoax: ExistingTelcoCoax;
  existingTelcoCoaxQuantity: number;
  existingTelcoConnections: ExistingTelcoConnections;
  existingVerticalCabling: ExistingVerticalCabling;
  nrOfCopperIntros: number;
  nrOfDesiredFibreIntros: number;
  accessToTelcoGeneralRemarks: string;
  buildingLayout: Layout;
  insideUnits: InsideSurvey[][];
  validatorRemark: string;
  surveyStatus: SurveyStatus;
  floorPlanPhotoRemark: string;

  nrOfGutters: number;
  nrOf90DegreeCorners: number;
  nrOfInsideOutsideCorners: number;
  nrOfEndKitsForGutters: number;
  nrOfHorizontalDrilling: number;
  nrOfVerticalDrilling: number;
  nrOfSealingKitsForDrillingHoles: number;
  sellingHigherThan3and5m: boolean;

  specialBuilding: boolean;
  specialBuildingRemark: string;

  heightOver3M50: boolean;
  specificHeightSpecialNeeds: boolean;

  specificInstructionsAesthetics: boolean;
  standardCableDuctsObligatory: boolean;
  specialCableDuctOrStandardCableDuctMoreThan20M: boolean;
  needForSpeedpipeTypeSheath: boolean;
  needForFlextubeTypeSheath: boolean;

  passageThroughExteriorHallway: boolean;
  passageOutsideSpecificEquipment: boolean;
  passageThroughFalseCeilings: boolean;
  passageThroughFalseFloor: boolean;
  floorboxNotOnSameFloorAsApartment: boolean;
  serviceLineConnection: boolean;
  severalTechnicalShafts: boolean;
  floorboxPresentInQuadrantC: boolean;
  extensionOfExistingTechnicalShaft: boolean;

  cableMoreThan50MOr2ManFiber: boolean;
  specialDrilling: boolean;
  mivbStibStation: boolean;
  accessToBuilding: boolean;
  shadowportfolioSolution: boolean;

  tsaType: TSAType;
  resurvey: boolean;
  isDocumentStatusPending: boolean;

  layoutPhoto: string;

  hasFailedValidateSurvey: boolean;
  failedValidateSurveyCommandId: string;
  hasOngoingValidateSurvey: boolean;
  hasSucceededValidateSurvey: boolean;

  get addresses() {
    return this.buildings.map((x) => x.addresses).reduce((a, b) => a.concat(b));
  }

  updateLayout(layout: LayoutProps) {
    this.shouldUpdateLayout = false;
    this.buildingLayout = Layout.create(layout);
  }
}
